import React from 'react';

export default function Pulse(props){
    return (
        <div className="pulse">
            <svg viewBox="0 0 310 350" {...props}>
                <path d="M156.4 339.5c31.8-2.5 59.4-26.8 80.2-48.5 28.3-29.5 40.5-47 56.1-85.1 14-34.3 20.7-75.6 2.3-111-18.1-34.8-55.7-58-90.4-72.3-11.7-4.8-24.1-8.8-36.8-11.5l-.9-.9-.6.6c-27.7-5.8-56.6-6-82.4 3-38.8 13.6-64 48.8-66.8 90.3-3 43.9 17.8 88.3 33.7 128.8 5.3 13.5 10.4 27.1 14.9 40.9 11.8 36.1 45.3 69.2 90.7 65.7z" />
            </svg>
        </div>
    )
}